export default __webpack_public_path__ + "static/media/bar.6354b32e.svg";